export default __webpack_public_path__ + "static/media/xButton.47490a6c.svg";